import FileView from "../../file-view";
import TextToHTML from "../../text-to-html";
import Typo from "../../typo";
import LinearProgressbar from "../../progressbar/linear";
import __ from "../../../utils/translate/translate";


const PlanCardWithMinScore = ({ cover, description, title, minScore, score }) => {
    return (
        <div className="w-full xs:w-80 aspect-4/3 relative p-7 rounded-xl overflow-hidden shrink-0 bg-linear-purple-7">
            <FileView  {...cover} thumbnail={undefined} className="inset-0 absolute" imageClassName="!aspect-4/3" />
            <div className="relative z-[1] flex flex-col gap-8">
                <TextToHTML className="text-white font-bold text-xl ui-clamp-1">
                    {description}
                </TextToHTML>
                <div className="flex gap-1 flex-col w-2/3">
                    <Typo size="sm" type="on-accent">{`${__("Until entering")} ${title}`}</Typo>
                    <LinearProgressbar value={score} max={minScore} />
                    <Typo size="xs" type="on-accent" className="self-end">{`${minScore - score} ${__("more score")}`}</Typo>
                </div>
            </div>
        </div>);
}

export default PlanCardWithMinScore;